import { Component } from '@angular/core';
import { ServiceProviderComponent } from '../service-provider/service-provider.component';

@Component({
    selector: 'app-service-provider-home-health',
    templateUrl: './service-provider-home-health.component.html',
    styleUrls: ['./service-provider-home-health.component.scss'],
    standalone: false
})
export class ServiceProviderHHComponent extends ServiceProviderComponent {}
